module.exports = __webpack_public_path__ + "e6b60018fd344e7eca22e6bf3b19efcd.MP3";